import Base from '../Base'

class News extends Base {
  constructor () {
    super()
    this.baseURL = process.env.API_BASE_URL
    this.getDetailUrl = '/api/introduce/details'
  }

  getDetail (params) {
    return this.sendGet(this.getDetailUrl, params)
  }
}

export default new News()
